/*** IMPORTS FROM imports-loader ***/
var define = false;

import sortedIndex from './sortedIndex.js';
import findIndex from './findIndex.js';
import createIndexFinder from './_createIndexFinder.js';

// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
export default createIndexFinder(1, findIndex, sortedIndex);




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/indexOf.js
// module id = 73
// module chunks = 0